import type { RecommendationDecisionRequestDto, TurnRequestExtras } from '../models/orpheus.dto'
import type { ChatMessage, WorkspaceId } from '../models/orpheus.types'
import type { MessageAttachment } from '../models/orpheusSetup.types'
import type { StreamState } from '../models/stream.types'

export interface LogicalTurn {
  turnId: string
  idempotencyKey: string
  workspaceId: WorkspaceId
  threadLocalId: string
  requestThreadId: string | null
  text: string
  recommendationDecision: RecommendationDecisionRequestDto | null
  userLocalId: string
  assistantLocalId: string
  state: StreamState
  attempts: number
  creditsApplied: boolean
  /** Body fields beyond the text — a resume replays exactly the same request. */
  requestExtras: TurnRequestExtras
}

export type { TurnRequestExtras } from '../models/orpheus.dto'

export interface PrepareTurnInput {
  workspaceId: WorkspaceId
  text: string
  turnId: string
  idempotencyKey: string
  userLocalId: string
  assistantLocalId: string
  threadLocalId: string
  recommendationDecision?: RecommendationDecisionRequestDto | null
  editIndex?: number
  now: string
  requestExtras?: TurnRequestExtras
  /** The file the user turn carried, shown on its bubble. */
  attachment?: MessageAttachment
  /**
   * Replay into an existing answer's slot instead of appending a turn: "Answer with Orphex
   * credits" asks the same question once more in place of the key-error card (ORP-25172).
   */
  replaceAssistantLocalId?: string
}

export function createEmptyMessage(params: {
  localId: string
  turnId: string
  role: 'user' | 'assistant'
  content: string
  index: number
  now: string
  streamState: StreamState
}): ChatMessage {
  return {
    localId: params.localId,
    turnId: params.turnId,
    messageId: null,
    role: params.role,
    kind: 'text',
    content: params.content,
    index: params.index,
    createdAt: params.now,
    updatedAt: params.now,
    streamState: params.streamState,
    answer: null,
    recommendations: [],
    recommendationData: null,
    responseBlocks: [],
    followups: [],
    suggestedPrompts: [],
    channels: [],
    controllerParams: null,
  }
}
